/* eslint-disable react/jsx-props-no-spreading */

// Utils
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CookiesProvider } from 'react-cookie';
import { AppProvider } from './store/AppContext';

// Components
import PopNotification from './components/organisms/PopNotification/PopNotification';

// Routes
import routes from './routes';

// React Query Client config
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <BrowserRouter>
            <Routes>
              {routes.map((route) => (
                <Route key={route.path} {...route} />
              ))}
            </Routes>

            <PopNotification />
          </BrowserRouter>
        </AppProvider>
      </QueryClientProvider>
    </CookiesProvider>
  );
}

export default App;
